// This file has some of the actions for customer details.
//TODO The customer details file needs to be broken down in to multiple ducks file based on the backend resource and this is part of the migration. Like accounts, transactions etc.
import {
  postCancelAccount,
  checkAccountCancelStatus,
} from 'services/accountDetails';
import { getPersonalInfo } from 'ducks/customerDetails';
import { poll } from 'utils/poll';

export const cancelAccount = (adfitNo, data) => async (dispatch, getState) => {
  const { accessToken } = getState().auth;

  const response = await postCancelAccount(adfitNo, data);

  if (!response.headers.has('location')) {
    throw new Error('');
  }

  const location = response.headers.get('location');

  const { errorMessage } = await poll(
    async () => {
      const statusResult = await checkAccountCancelStatus(
        location,
        accessToken
      );

      //Keep polling if the result is submitted by throwing error.
      if (
        !statusResult ||
        statusResult.currentState.toLowerCase() === 'submitted'
      ) {
        throw new Error('');
      }
      return statusResult;
    },
    5000,
    10
  );

  if (errorMessage) {
    throw new Error(errorMessage);
  }

  //check if we are still in the same page.
  const currentAdfitNo = getState().customerDetails.adfitNo;
  if (currentAdfitNo === adfitNo) {
    await dispatch(getPersonalInfo(adfitNo));
  }
};
